import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "download-circle",
  "use": "download-circle-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"download-circle\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#6644EA\" stroke-width=\".5\"><circle cx=\"8\" cy=\"8\" r=\"7.75\" fill=\"#FFF\" /><g stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12 8.53v1.646c0 .455-.398.824-.889.824H4.89c-.492 0-.89-.369-.89-.824V8.53\" /><path d=\"M5.778 6.882 8 8.941l2.222-2.059M8 8.941V4\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol